// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #525dd4;
  --accent-color: #1fd248;
  --fill-color: #000000;
  --font-theme-color: #ffffff;
  --background-color: #ffffff;
  --html-background-color: #ffffff;
  --card-background-color: #ffffff;
  --text-color: #1e1e1e;
  --text-light-color: #646464;
  --border-color: #ebebeb;
  --border-button-color: #f3f3f3;
  --button-default-icon-color: #474747;
  --tooltip-theme-color: #ffffff;

  --font-family-base: "Inter", sans-serif;
  --font-family-heading: "Poppins", sans-serif;
  --font-size-tiny: 0.666rem; /* 10px */
  --font-size-small: 0.733rem; /* 11px */
  --font-size-base: 1rem; /* 15px */
  --font-size-h1: 1.867rem; /* 28px */
  --font-size-h2: 1.066rem; /* 16px */
  --line-height-base: 1.5;

  --spacing-extra-small: 0.133rem; /* 4px */
  --spacing-tiny: 0.4rem; /* 6px */
  --spacing-small: 0.533rem; /* 8px */
  --spacing-mini: 0.8rem; /* 12px */
  --spacing-base: 1rem; /* 15px */
  --spacing-meduim: 1.333rem; /* 20px */
  --spacing-large: 2rem; /* 30px */
  --spacing-extra-large: 3.333rem; /* 50px */

  --border-solid: 1px solid;
  --border-radius-small: 0.8rem; /* 12px */
  --border-radius-base: 1.333rem; /* 20px */
  --border-radius-large: 1.6rem; /* 24px */

  --box-shadow-button: 0 2px 6px rgba(0, 0, 0, 0.1);
}

[data-theme="dark"] {
  --background-color: #0d1118;
  --html-background-color: #0d1118;
  --card-background-color: #171d29;
  --border-button-color: #525dd4;
  --border-color: #525dd4;
  --text-color: #ffffff;
  --text-light-color: #d7d5ff;
  --fill-color: #ffffff;
  --button-default-icon-color: #525dd4;
}

/* Special Theme - New Year */
[data-theme="special"] {
  --background-color: radial-gradient(50% 51.7% at 50% 0%, #0d7073, #00291d);
  --html-background-color: #08463f;
  --card-background-color: #0d70732e;
  --text-color: #f7c953;
  --text-light-color: #f5edc9;
  --special-text-theme-color: #420c0c;
  --primary-color: #ffffff;
  --accent-color: #cda43c;
  --border-color: rgba(255, 246, 157, 0.8);
  --border-solid: 1px solid transparent;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,gCAAgC;EAChC,gCAAgC;EAChC,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;;EAE9B,uCAAuC;EACvC,4CAA4C;EAC5C,0BAA0B,EAAE,SAAS;EACrC,2BAA2B,EAAE,SAAS;EACtC,sBAAsB,EAAE,SAAS;EACjC,wBAAwB,EAAE,SAAS;EACnC,wBAAwB,EAAE,SAAS;EACnC,uBAAuB;;EAEvB,+BAA+B,EAAE,QAAQ;EACzC,sBAAsB,EAAE,QAAQ;EAChC,yBAAyB,EAAE,QAAQ;EACnC,sBAAsB,EAAE,SAAS;EACjC,oBAAoB,EAAE,SAAS;EAC/B,0BAA0B,EAAE,SAAS;EACrC,qBAAqB,EAAE,SAAS;EAChC,+BAA+B,EAAE,SAAS;;EAE1C,yBAAyB;EACzB,6BAA6B,EAAE,SAAS;EACxC,8BAA8B,EAAE,SAAS;EACzC,6BAA6B,EAAE,SAAS;;EAExC,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,6BAA6B;AAC7B;EACE,0EAA0E;EAC1E,gCAAgC;EAChC,kCAAkC;EAClC,qBAAqB;EACrB,2BAA2B;EAC3B,mCAAmC;EACnC,wBAAwB;EACxB,uBAAuB;EACvB,wCAAwC;EACxC,qCAAqC;AACvC","sourcesContent":[":root {\n  --primary-color: #525dd4;\n  --accent-color: #1fd248;\n  --fill-color: #000000;\n  --font-theme-color: #ffffff;\n  --background-color: #ffffff;\n  --html-background-color: #ffffff;\n  --card-background-color: #ffffff;\n  --text-color: #1e1e1e;\n  --text-light-color: #646464;\n  --border-color: #ebebeb;\n  --border-button-color: #f3f3f3;\n  --button-default-icon-color: #474747;\n  --tooltip-theme-color: #ffffff;\n\n  --font-family-base: \"Inter\", sans-serif;\n  --font-family-heading: \"Poppins\", sans-serif;\n  --font-size-tiny: 0.666rem; /* 10px */\n  --font-size-small: 0.733rem; /* 11px */\n  --font-size-base: 1rem; /* 15px */\n  --font-size-h1: 1.867rem; /* 28px */\n  --font-size-h2: 1.066rem; /* 16px */\n  --line-height-base: 1.5;\n\n  --spacing-extra-small: 0.133rem; /* 4px */\n  --spacing-tiny: 0.4rem; /* 6px */\n  --spacing-small: 0.533rem; /* 8px */\n  --spacing-mini: 0.8rem; /* 12px */\n  --spacing-base: 1rem; /* 15px */\n  --spacing-meduim: 1.333rem; /* 20px */\n  --spacing-large: 2rem; /* 30px */\n  --spacing-extra-large: 3.333rem; /* 50px */\n\n  --border-solid: 1px solid;\n  --border-radius-small: 0.8rem; /* 12px */\n  --border-radius-base: 1.333rem; /* 20px */\n  --border-radius-large: 1.6rem; /* 24px */\n\n  --box-shadow-button: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n[data-theme=\"dark\"] {\n  --background-color: #0d1118;\n  --html-background-color: #0d1118;\n  --card-background-color: #171d29;\n  --border-button-color: #525dd4;\n  --border-color: #525dd4;\n  --text-color: #ffffff;\n  --text-light-color: #d7d5ff;\n  --fill-color: #ffffff;\n  --button-default-icon-color: #525dd4;\n}\n\n/* Special Theme - New Year */\n[data-theme=\"special\"] {\n  --background-color: radial-gradient(50% 51.7% at 50% 0%, #0d7073, #00291d);\n  --html-background-color: #08463f;\n  --card-background-color: #0d70732e;\n  --text-color: #f7c953;\n  --text-light-color: #f5edc9;\n  --special-text-theme-color: #420c0c;\n  --primary-color: #ffffff;\n  --accent-color: #cda43c;\n  --border-color: rgba(255, 246, 157, 0.8);\n  --border-solid: 1px solid transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
